(function () {
  document.querySelectorAll('[data-dp-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('.dp-header-nav__dropdown-wrap');
      var isOpen = wrap.classList.contains('is-open');
      document.querySelectorAll('.dp-header-nav__dropdown-wrap.is-open').forEach(function (w) {
        w.classList.remove('is-open');
      });
      if (!isOpen) wrap.classList.add('is-open');
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.dp-header-nav__dropdown-wrap')) {
      document.querySelectorAll('.dp-header-nav__dropdown-wrap.is-open').forEach(function (w) {
        w.classList.remove('is-open');
      });
    }
  });

  // Menú móvil (panel lateral con hamburguesa)
  var mobileMenu = document.querySelector('[data-dp-mobile-menu]');
  var mobileToggle = document.querySelector('[data-dp-mobile-menu-toggle]');
  if (mobileMenu && mobileToggle) {
    document.body.appendChild(mobileMenu);
    mobileToggle.addEventListener('click', function () {
      mobileMenu.hidden = false;
      mobileToggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    });
    mobileMenu.querySelectorAll('[data-dp-mobile-menu-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        mobileMenu.hidden = true;
        mobileToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  // Lupa de búsqueda visible solo cuando el header está en modo compacto
  var compactSearchToggle = document.querySelector('[data-dp-compact-search-toggle]');
  var searchWrap = document.querySelector('.dp-header-main__search-wrap');
  if (compactSearchToggle && searchWrap) {
    compactSearchToggle.addEventListener('click', function () {
      var isVisible = searchWrap.style.display === 'block';
      searchWrap.style.display = isVisible ? '' : 'block';
      if (!isVisible) {
        var input = searchWrap.querySelector('input');
        if (input) input.focus();
      }
    });
  }

  var header = document.querySelector('.dp-header-main');
  var nav = document.querySelector('[data-dp-sticky-nav]');
  if (!header || !nav) return;

  // Centinela: un marcador invisible justo donde empieza el header.
  // En vez de "recordar" una posición calculada una vez, comprobamos
  // en tiempo real si ese punto sigue visible o ya se ha ido de la pantalla.
  var sentinel = document.createElement('div');
  sentinel.style.cssText = 'height:1px; visibility:hidden;';
  header.parentNode.insertBefore(sentinel, header);

  var spacer = document.createElement('div');
  spacer.style.display = 'none';
  nav.parentNode.insertBefore(spacer, nav);

  var fixedActive = false;

  function applyFixed() {
    if (fixedActive) return;
    header.classList.add('dp-is-fixed');
    nav.classList.add('dp-is-fixed');
    applyCompact();
    fixedActive = true;

    // Esperar un frame a que el navegador aplique el CSS del "encogido"
    // antes de medir la altura real del header (si no, coge la altura vieja).
    requestAnimationFrame(function () {
      var totalHeight = header.offsetHeight + nav.offsetHeight;
      spacer.style.height = totalHeight + 'px';
      spacer.style.display = 'block';
      nav.style.top = header.offsetHeight + 'px';
    });
  }

  function removeFixed() {
    if (!fixedActive) return;
    header.classList.remove('dp-is-fixed');
    nav.classList.remove('dp-is-fixed');
    nav.style.top = '';
    spacer.style.display = 'none';
    fixedActive = false;
    removeCompact();
  }

  // En móvil, además de fijar el header, lo encoge (oculta buscador, logo más pequeño)
  var isMobile = window.matchMedia('(max-width: 749px)').matches;

  function applyCompact() {
    if (!isMobile) return;
    header.classList.add('dp-is-compact');
  }

  function removeCompact() {
    header.classList.remove('dp-is-compact');
    if (searchWrap) searchWrap.style.display = '';
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        removeFixed();
      } else if (entry.boundingClientRect.top < 0) {
        applyFixed();
      }
    });
  }, { threshold: 0 });

  observer.observe(sentinel);
})();